import _ from 'lodash';
import _swal from './swal';
import _axios from './axios';
import _lodash from './lodash';

const axios = _.merge({}, _axios);
const lodash = _.merge({}, _lodash);
const swal = _.merge({}, _swal);

export {
    axios,
    lodash,
    swal,
};
